import { colors, fonts } from '@grupoboticario/flora-tokens/dist/mooz/web/ds'

export const mooz = {
  colors,
  fonts,
}
